'use strict';
angular.module('mediaSelectorModule', ['mediaSelectorSeviceModule']).controller('mediaSelectorCtrl', [
    '$scope',
    '$q',
    '$modalInstance',
    '$timeout',
    'trsHttpService',
    'options',
    'modalDialog',
    'getFileMD5Service',
    'mrApiService',
    'trsspliceString',
    '$validation',
    '$state',
    '$sce',
    'localStorageService',
    'editCenUploadVideoForXjService',
    'mrService',
    'materialConst',
    '$sessionStorage',
    'mediaSelectorSevice',
    function (
        $scope,
        $q,
        $modalInstance,
        $timeout,
        trsHttpService,
        options,
        modalDialog,
        getFileMD5Service,
        mrApiService,
        trsspliceString,
        $validation,
        $state,
        $sce,
        localStorageService,
        editCenUploadVideoForXjService,
        mrService,
        materialConst,
        $sessionStorage,
        mediaSelectorSevice
    ) {
        initStatus();
        initData();

        /**
         * [initStatus 初始化状态]
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.windowTitle = options.resourceType === '0' ? '选择图片' : options.resourceType === '1' ? '选择音频' : '选择视频';
            $scope.page = {
                ITEMCOUNT: 0,
                CURRPAGE: 1,
                PAGESIZE: 8,
                PAGECOUNT: 1,
            };
            // data数据
            $scope.basicalData = {
                // articleClassArr: [],
            };
            // 状态初始化
            $scope.basicalStatus = angular.extend(
                {
                    allowPicSearch: false,
                    isShowPeraonalMaterial: true, // 是否显示添加到个人素材库的checkbox
                    materialStatus: materialConst.allStatusMap,
                },
                mrService.getMediaBasicStatus()
            );
            $scope.basicalStatus.commonParams.mainResourceType = options.resourceType;
            $scope.items = [];
            $scope.selectedArray = [];
            $scope.status = {
                isWeixin: options.isWeixin,
                isAddPersonalMaterial:
                    JSON.parse(sessionStorage.getItem('isChecked')) === null ? true : JSON.parse(sessionStorage.getItem('isChecked')), // 是否选中添加到个人素材库
                complete: 100, // 上传完成
                unit: 1024, // 单位
                burst: 5, // 分片
                division: 20, // 分片间隔数，超过该数认为是大视频
                uploadNum: 0,
                waitTime: $scope.basicalStatus.commonParams.mainResourceType === '0' ? 1000 : 5000,
                messagePicUrl: `${trsHttpService.getMRURL()}/personal/0/upload`,
                videoType: editCenUploadVideoForXjService.singleVideoOption.accept.extensions,
                audioType: editCenUploadVideoForXjService.singleAudioOption.accept.extensions,
                pictureType: editCenUploadVideoForXjService.singleImageOption.extensions,
                canSaveMaterial: false,
                isShowVideoLink: typeof options.isShowVideoLink !== 'undefined' ? options.isShowVideoLink : true,
                imgFormdata: {
                    'mrEnable': '0'
                }
            };
            $scope.uploadObj = null;
            mediaSelectorSevice.initVideoUploader($scope).then((uploader) => {
                $scope.uploader = uploader;
                if ($scope.basicalStatus.commonParams.mainResourceType === '1' && $scope.uploader.uploaderOptions) {
                    $scope.uploader.uploaderOptions.accept = {
                        title: '音频',
                        extensions: 'mp3,flac,wav,wma',
                        mimeTypes: 'audio/*',
                    };
                }
            });

            $scope.tagsData = {
                tags: [], // 选中的标签列表
                tagsList: [], // 搜索出的标签列表
                searchTags: '', // 标签搜索关键字
                selectedTag: {}, // 选中标签对象
            };
            $scope.resourceType = options.resourceType;
            $scope.data = {
                navs: getNavs(),
                currFileId: '0', // 当前文件夹的id
                keywords: '', // 检索关键词
                picList: [],
                alignment: {
                    // iframe的对齐方式
                    values: [
                        {
                            name: '居中',
                            value: '0',
                        },
                        {
                            name: '左对齐',
                            value: '1',
                        },
                        {
                            name: '右对齐',
                            value: '2',
                        },
                    ],
                    curValue: {
                        name: '居中',
                        value: '0',
                    },
                },
                // 人物标签
                personTips: [],
                // 地点标签
                placeTips: [],
                // 事物标签
                thingTips: [],
                videoUrl: '',
                selectedNav: '2'
            };
            $scope.mainResourceType = options.resourceType;
            $scope.materialTypeTransform = { // 素材库类型文字转换
                '0': '图片',
                '1': '音频',
                '2': '视频'
            };
            // 上传的对象数组
            $scope.unuploadList = [];
            $scope.uploadListCache = [];
            $scope.uploadImages = {
                success: function (file, src) {
                    for (let i = 0; i < $scope.unuploadList.length; i++) {
                        if ($scope.unuploadList[i].id === file.id) {
                            $scope.status.uploadNum--;
                            $scope.unuploadList[i].progress = '100%';
                            $scope.unuploadList[i].status = '正在处理中...';
                            $scope.status.canSaveMaterial = false;
                            $scope.unuploadList[i].relationid = src.datas.relationid;
                            $scope.unuploadList[i].personTips = src.datas.labelvos;
                            $scope.setUploadItemCache(i, $scope.unuploadList[i]);
                            $scope.$apply();
                            $scope.startInterval($scope.unuploadList[i], i);
                            break;
                        }
                    }
                },
                error: function (file, msg) {
                    modalDialog.alertType('上传失败', msg || '请重新上传', 'error', false);
                    for (let i = 0; i < $scope.unuploadList.length; i++) {
                        if ($scope.unuploadList[i].id === file.id) {
                            $scope.unuploadList[i].status = '上传失败';
                            break;
                        }
                    }
                    $scope.deleteList(file);
                },
                file: function (file, uploader) {
                },
                tar: function (file, percentage) {
                    for (let i = 0; i < $scope.unuploadList.length; i++) {
                        if ($scope.unuploadList[i].id === file.id) {
                            $scope.unuploadList[i].progress = percentage.toFixed(2) + '%';
                            $scope.$apply();
                            break;
                        }
                    }
                },
                start: function (file) {
                    let fileName = angular.copy(file.name);
                    // file.selectClass = $scope.basicalData.articleClassArr[0];
                    file.fileName = fileName.substring(0, fileName.lastIndexOf('.'));
                    file.mrEnable = '0';
                    $scope.unuploadList.push(file);
                    $scope.unuploadList[$scope.unuploadList.length - 1].status = '正在上传中...';
                    $scope.status.canSaveMaterial = false;
                    $scope.unuploadList[$scope.unuploadList.length - 1].progress = '0%';
                    $scope.status.uploadNum++;
                    mrApiService.getExifInfo($scope.unuploadList[$scope.unuploadList.length - 1].source.source, $scope.unuploadList[$scope.unuploadList.length - 1]);
                    $scope.$apply();
                },
                comp: function (file) {
                    //
                },
                finish: function (file) {
                    //
                },
            };
            $scope.isWeibo = options.isWeibo || false;
            if ($scope.isWeibo) {
                $scope.weiboList = options.otherOptions.list;
            }
            if ($scope.status.isWeixin) {
                dealWeChatTrench();
            }
        }

        /**
         * [dealWeChatTrench description] 单独处理微信渠道
         * @return  {[type]}  [return description]
         */
        function dealWeChatTrench() {
            if (options.resourceType === '2') {
                $scope.data.selectedNav = 'videoLink';
                $scope.data.navs = [{
                    name: '视频链接',
                    value: 'videoLink',
                }];
            }
        }

        /**
         * [setUploadItemCache 缓存文件信息，避免获取详情后文件对象改变]
         * @param   {[type]}  index  [index description]
         * @param   {[type]}  item   [item description]
         * @return  {[type]}         [return description]
         */
        $scope.setUploadItemCache = function(index, item) {
            $scope.uploadListCache[index] = item;
        };

        /**
         * [closeFolder description] 关闭文件夹，返回上一级
         * @return  {[type]}  [return description]
         */
        $scope.closeFolder = function () {
            $scope.basicalStatus.searchParams = localStorageService.get('materialSearchParams');
            $scope.page.CURRPAGE = $scope.basicalStatus.searchParams.pageNum;
            $scope.basicalStatus.searchParams.fileId = 0;
            $scope.basicalStatus.isInFolder = false;
            $scope.basicalStatus.currentFolderId = 0;
            $scope.tagsData.tags = [];
            $scope.isWithFilters = false;
            $scope.requestData();
        };

        /**
         * [clearPageData 清除页面数据]
         *
         * @return  {[type]}  [return description]
         */
        function clearPageData() {
            $scope.items = [];
            $scope.selectedArray = [];
        }

        /**
         * 获取文件夹内素材
         * @param   {[type]}  fileId  [fileId description]
         * @return  {[type]}          [return description]
         */
        $scope.getFolderMaterial = function () {
            setFolderSearchParam();
            clearPageData();
            sendFolderSearchRequest();
        };

        /**
         * [setFolderSearchParam 设置文件夹内容检索参数]
         *
         * @return  {[type]}  [return description]
         */
        function setFolderSearchParam() {
            $scope.basicalStatus.folderSearchParams.relationId = $scope.basicalStatus.currentFolderId;
            if ($scope.basicalStatus.searchParams.fileId === 0) {
                $scope.page.CURRPAGE = 1;
            }
            $scope.basicalStatus.searchParams = mrApiService.resetSearchparams();
            $scope.basicalStatus.searchParams.fileId = $scope.basicalStatus.currentFolderId;
        }

        /**
         * [sendFolderSearchRequest 文件夹内容检索请求]
         * @return  {[type]}  [return description]
         */
        function sendFolderSearchRequest() {
            let params = angular.extend(
                {},
                $scope.basicalStatus.commonParams,
                $scope.basicalStatus.folderSearchParams,
                $scope.basicalStatus.orderParams
            );
            $scope.loadingPromise = mrApiService.getFolderMaterialData(params).then(
                function (data) {
                    if (data.code === '200') {
                        $scope.items = data.datas;
                        transferPage(data.summary_info);
                    } else {
                        modalDialog.alertType(data.code, data.msg, 'error', false);
                        $scope.items = [];
                        $scope.page.ITEMCOUNT = 0;
                    }
                },
                function (data) {
                    modalDialog.alertType(data.code, data.msg, 'error', false);
                    $scope.items = [];
                    $scope.page.ITEMCOUNT = 0;
                }
            );
        }

        /**
         * [requestData 数据请求]
         *
         * @return  {[type]}  [return description]
         */
        $scope.requestData = function () {
            requestData();
        };

        /**
         * [requestData 请求数据方法定义]
         *
         * @return  {[type]}  [return description]
         */
        function requestData() {
            if ($scope.basicalStatus.isInFolder) {
                if ($scope.basicalStatus.isWithFilters) {
                    resourceSearchData();
                } else {
                    $scope.getFolderMaterial();
                }
            } else if ($scope.basicalStatus.isWithFilters) {
                resourceSearchData();
            } else {
                resourceSearchData();
            }
        }

        /**
         * [transferPage 将媒资库分页数据转换为分页组件数据格式]
         * @param   {[type]}  pageInfo  [pageInfo description]
         * @return  {[type]}            [return description]
         */
        function transferPage(pageInfo) {
            $scope.page.ITEMCOUNT = pageInfo.total;
            $scope.page.PAGECOUNT = Math.ceil(pageInfo.total / pageInfo.pageSize);
        }

        /**
         * [resourceSearchData 检索海贝数据]
         * @return  {[type]}  [return description]
         */
        function resourceSearchData() {
            clearPageData();
            let deffered = $q.defer();
            $scope.loadingPromise = mrApiService
                .getMaterialData(angular.extend({}, $scope.basicalStatus.commonParams, $scope.basicalStatus.searchParams))
                .then(
                    function (data) {
                        if (data.code === '200') {
                            $scope.items = data.datas;
                            $scope.page.ITEMCOUNT = data.summary_info.total;
                            $scope.page.CURRPAGE = data.summary_info.pageNum;
                            $scope.page.PAGECOUNT = Math.ceil(data.summary_info.total / $scope.page.pageSize);
                            deffered.resolve(data);
                        } else {
                            modalDialog.alertType(data.code, '请求数据失败', 'error', false);
                            deffered.reject(data);
                        }
                    },
                    function (data) {
                        modalDialog.alertType(data.code, data.msg, 'error', false);
                        deffered.reject(data);
                    }
                );
            return deffered.promise;
        }

        /**
         * [initData 初始化数据]
         * @return  {[type]}  [return description]
         */
        function initData() {
            setVideoSize();
            getFileMD5Service.init();
            // mediaSelectorSevice.loadDirective();
        }

        /**
         * [loadTags description] 选择标签输入框回调函数
         * @param   {[type]}  val  [val description] 输入值
         * @return  {[type]}       [return description]
         */
        $scope.loadTags = function (val) {
            if (!val) {
                $scope.tagsData.tagsList = [];
                return;
            }
            mrApiService.getMark({ mark: val }).then(function (data) {
                $scope.tagsData.tagsList = data.datas;
            });
        };

        /**
         * [searchByTags 根据标签检索]
         * @param   {[type]}  bool  [bool 是否新增标签，true-新增了，false-删除了标签]
         * @return  {[type]}        [return description]
         */
        $scope.searchByTags = function () {
            if (!$scope.basicalStatus.isWithFilters) {
                $scope.basicalStatus.searchParams.pageNum = $scope.page.CURRPAGE = 1;
            }
            if ($scope.basicalStatus.commonParams.mainResourceType === '0') {
                $scope.basicalStatus.searchParams.mark = trsspliceString.spliceString($scope.tagsData.tags, 'id', ';');
            } else {
                $scope.basicalStatus.searchParams.mark = trsspliceString.spliceString($scope.tagsData.tags, 'text', ';');
            }
            $scope.basicalStatus.isWithFilters = !!$scope.tagsData.tags.length;
            if (!$scope.basicalStatus.isWithFilters) {
                $scope.page.CURRPAGE = $scope.basicalStatus.folderSearchParams.pageNum = $scope.basicalStatus.copyCurrPage;
            }
            $scope.requestData();
        };

        /**
         * [getNavs 获取导航条]
         *
         * @return  {[type]}  [return description]
         */
        function getNavs() {
            let picNav = [
            	// {
                //     name: '媒资库',
                //     value: '0',
                //     mrType: 'meizi',
                // },
                {
                    name: '个人素材',
                    value: '1',
                    mrType: 'personal',
                },
                // {
                //     name: '已编素材',
                //     value: '3',
                //     mrType: 'edited',
                // },
                // {
                //     name: '共享素材',
                //     value: '4',
                //     mrType: 'share',
                // },
                {
                    name: '本地图片',
                    value: '2',
                },
            ];
            let autioNav = [
                {
                    name: '个人素材',
                    value: '1',
                    mrType: 'personal',
                },
                // {
                //     name: '已编素材',
                //     value: '3',
                //     mrType: 'edited',
                // },
                // {
                //     name: '共享素材',
                //     value: '4',
                //     mrType: 'share',
                // },
                {
                    name: '本地音频',
                    value: '2',
                },
            ];
            let videoNav = [
            	// {
                //     name: '媒资库',
                //     value: '0',
                //     mrType: 'meizi',
                // },
                {
                    name: '个人素材',
                    value: '1',
                    mrType: 'personal',
                },
                // {
                //     name: '已编素材',
                //     value: '3',
                //     mrType: 'edited',
                // },
                // {
                //     name: '共享素材',
                //     value: '4',
                //     mrType: 'share',
                // },
                {
                    name: '本地视频',
                    value: '2',
                },
            ];
            if ($scope.status.isShowVideoLink) {
                videoNav.splice(3, 0, {
                    name: '视频链接',
                    value: 'videoLink',
                });
            }

            let navs = {
                '0': picNav,
                '1': autioNav,
                '2': videoNav,
            };
            return navs[options.resourceType];
        }

        /**
         * [uploadTest description]视频上传
         * @return {[type]} [description]
         */
        $scope.upload = function () {
            mediaSelectorSevice.doUploader();
        };

        /**
         * [startInterval 设置素材信息获取定时器]
         * @param   {[type]}  item  [item description]
         * @param   {[type]}  index  [item description]
         * @return  {[type]}        [return description]
         */
        $scope.startInterval = function(item, index) {
            if (item.fastVideoTimer) {
                $timeout.cancel(item.fastVideoTimer);
            }
            item.fastVideoTimer = $timeout(
                function () {
                    if ($scope.basicalStatus.commonParams.mainResourceType !== '0') {
                        $scope.unuploadList[index].status = '正在转码中...';
                        $scope.status.canSaveMaterial = true;
                        // $scope.status.uploadNum--;
                    }
                    getVideoInfo(item, index).then(function () {
                        beginTimeout(item, index);
                    });
                },
                $scope.basicalStatus.commonParams.mainResourceType === '0' ? 0 : 5000
            );
        };

        /**
         * [beginTimeout 开始运行素材信息获取定时器]
         * @param   {[type]}  item  [item description]
         * @param   {[type]}  index  [item description]
         * @return  {[type]}        [return description]
         */
        function beginTimeout(item, index) {
            item.fastVideoTimer = $timeout(function () {
                getVideoInfo(item, index).then(function () {
                    beginTimeout(item, index);
                });
            }, $scope.status.waitTime);
        }

        /**
         * [getVideoInfo 获取视频详情]
         * @param   {[type]}  item  [item description]
         * @param   {[type]}  index  [item description]
         * @return  {[type]}        [return description]
         */
        function getVideoInfo(item, index) {
            var deffer = $q.defer();
            let mediaFormatFailCode = -10;
            let mediaFormatingCode = 10;
            let mediaCheckFailCode = -1;
            let mediaCheckingCode = 0;
            let relationId = item.relationid || item.relationId;
            if (relationId) {
                mrApiService.getMaterialDetail(angular.extend({ relationId: relationId }, $scope.basicalStatus.commonParams)).then(
                    function (data) {
                        if (data.datas[0] && data.datas[0].resourcestatus !== mediaFormatingCode) {
                            if (data.datas[0].resourcestatus === mediaCheckingCode) {
                                $scope.unuploadList[index].videoid = data.datas[0].videoid;
                                $scope.unuploadList[index].resourceid = data.datas[0].resourceid;
                                $scope.unuploadList[index].relationid = data.datas[0].relationid;
                                deffer.resolve();
                            } else {
                                if (data.datas[0].resourcestatus === mediaFormatFailCode) {
                                    item.status = '转码失败';
                                    $scope.status.canSaveMaterial = false;
                                } else {
                                    delete data.datas[0].filminglocation;
                                    delete data.datas[0].filmingtime;
                                    $scope.unuploadList[index] = Object.assign($scope.unuploadList[index], data.datas[0]);
                                    $scope.unuploadList[index].URL = data.datas[0].previewurl || data.datas[0].useableurl;
                                    $scope.unuploadList[index].status = '转码完成';
                                    item.URL = data.datas[0].previewurl || data.datas[0].useableurl;
                                    item.resourcestatus = data.datas[0].resourcestatus;
                                    item.resourceid = data.datas[0].resourceid;
                                    $scope.status.canSaveMaterial = true;
                                    $scope.unuploadList[index].fileName = data.datas[0].resourcetitle;
                                    // $scope.unuploadList[index].selectClass = $scope.basicalData.articleClassArr[0];
                                    $scope.unuploadList[index].relationid = data.datas[0].relationid;
                                    if ($scope.uploadListCache.length){
                                        $scope.unuploadList[index].personmark = $scope.uploadListCache[index].personmark;
                                        $scope.unuploadList[index].placemark = $scope.uploadListCache[index].placemark;
                                        $scope.unuploadList[index].eventmark = $scope.uploadListCache[index].eventmark;
                                    }
                                    if (data.datas[0].resourcestatus === mediaCheckFailCode) {
                                        // $scope.status.canSaveMaterial = false;
                                        item.isShowAuditingStatus = false;
                                        item.audidingErrors = [];
                                    }
                                }
                                deffer.reject();
                            }
                        } else {
                            $scope.unuploadList[index].resourcetype = options.resourceType;
                            $scope.unuploadList[index].videoid = data.datas[0].videoid;
                            $scope.unuploadList[index].resourceid = data.datas[0].resourceid;
                            $scope.unuploadList[index].relationid = data.datas[0].relationid;
                            $scope.unuploadList[index].mrtype = data.datas[0].mrtype;
                            $scope.unuploadList[index].resourcestatus = data.datas[0].resourcestatus;
                            if ($scope.uploadListCache && $scope.uploadListCache.length){
                                $scope.unuploadList[index].personmark = $scope.uploadListCache[index].personmark;
                                $scope.unuploadList[index].placemark = $scope.uploadListCache[index].placemark;
                                $scope.unuploadList[index].eventmark = $scope.uploadListCache[index].eventmark;
                            }
                            deffer.resolve();
                        }
                    },
                    function () {
                        deffer.resolve();
                        modalDialog.alertType('查询信息失败', '重新查询', 'warning', false);
                    }
                );
            } else {
                deffer.reject();
            }

            return deffer.promise;
        }

        /**
         * [deleteList 删除视频]
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        $scope.deleteList = function (item) {
            if (item.status === '正在上传中...') {
                modalDialog.alertType('请等待上传完成后在删除！', '', 'info');
                return;
            }
            var i = $scope.unuploadList.indexOf(item);
            if ($scope.unuploadList[i].relationId || $scope.unuploadList[i].relationid) {
                mrApiService.deleteMaterial(
                    angular.extend({ relationIds: $scope.unuploadList[i].relationId || $scope.unuploadList[i].relationid }, $scope.basicalStatus.commonParams)
                );
            } else {
                $scope.status.uploadNum--;
            }
            $timeout.cancel($scope.unuploadList[i].fastVideoTimer);
            if ($scope.uploadObj && $scope.basicalStatus.commonParams.mainResourceType !== '0') {
                $scope.uploadObj.removeFile($scope.unuploadList[i]);
            }
            $scope.unuploadList.splice(i, 1);
            $scope.uploadListCache.splice(i, 1);
        };

        /**
         * [saveMessage 保存本地上传素材]
         *
         * @return  {[type]}  [return description]
         */
        function saveMessage() {
            if ($scope.status.uploadNum > 0) {
                modalDialog.alertType('', '素材仍在上传中请稍候', 'warning', false);
                return;
            }
            if (!options.isMulti && $scope.unuploadList.length > 1) {
                modalDialog.alertType('警告', '只能上传一个', 'warning', false);
                return;
            }
            if (options.isMulti && options.maxSize > 0 && $scope.unuploadList.length > options.maxSize) {
                modalDialog.alertType('警告', '最多只能上传' + options.maxSize + '个素材', 'warning', false);
                return;
            }
            updateMaterial().then(
                () => {
                    $scope.unuploadList.forEach(function (element) {
                        $timeout.cancel(element.fastVideoTimer);
                    });
                    returnResult();
                },
                () => {
                    $scope.unuploadList.forEach(function (element) {
                        $timeout.cancel(element.fastVideoTimer);
                    });
                    modalDialog.alertType('保存到素材库失败', '请重试', 'warning', false);
                    returnResult();
                }
            );
        }

        /**
         * [returnResult 返回结果]
         *
         * @return  {[type]}  [return description]
         */
        function returnResult() {
            if ($scope.mainResourceType === '0') {
                returnPictureResult();
            } else {
                returnVideoResult();
            }
        }

        /**
         * [returnVideoResult 返回视频选择结果]
         *
         * @return  {[type]}  [return description]
         */
        function returnVideoResult() {
            if ($scope.isWeibo) {
                setWeiboVideo($scope.unuploadList[0]);
                $modalInstance.close({
                    list: $scope.weiboList,
                    videoUrl: $scope.data.videoUrl,
                    uploader: $scope.uploader,
                });
            } else {
                $modalInstance.close({
                    list: $scope.unuploadList,
                    isAddPersonalMaterial: $scope.status.isAddPersonalMaterial && $scope.data.selectedNav === '2',
                });
            }
        }

        /**
         * [returnPictureResult 返回图片选择结果]
         *
         * @return  {[type]}  [return description]
         */
        function returnPictureResult() {
            if ($scope.isWeibo) {
                setPics($scope.unuploadList).then(function () {
                    let result = {
                        list: $scope.weiboList,
                    };
                    $modalInstance.close(result);
                });
            } else {
                $modalInstance.close({
                    list: $scope.unuploadList,
                    isAddPersonalMaterial: $scope.status.isAddPersonalMaterial && $scope.data.selectedNav === '2',
                });
            }
        }

        /**
         * [setPics description] 组装图片
         *
         * @param   {[type]}  array  [array description]
         *
         * @return  {[type]}         [return description]
         */
        function setPics(array) {
            let deffer = $q.defer();
            let pics = array
                .filter((item, index) => !!item.previewurl)
                .map((item, index) => item.previewurl)
                .join(';');
            $timeout(function () {
                $scope.weiboList.PICTURE = $scope.weiboList.PICTURE === '' ? $scope.weiboList.PICTURE + pics : $scope.weiboList.PICTURE + ';' + pics;
                deffer.resolve();
            });
            return deffer.promise;
        }


        /**
         * [updateMaterial 更新素材信息]
         * @return  {[type]}  [return description]
         */
        function updateMaterial() {
            var deffer = $q.defer();
            var check = true;
            var index = 0;
            $scope.unuploadList.forEach((item) => {
                var eventmark = '';
                var personmark = '';
                var placemark = '';
                if ($scope.basicalStatus.commonParams.mainResourceType !== '0') {
                    eventmark = trsspliceString.spliceString(angular.copy(item.eventmark), 'name', ';');
                    personmark = trsspliceString.spliceString(angular.copy(item.personmark), 'name', ';');
                    placemark = trsspliceString.spliceString(angular.copy(item.placemark), 'name', ';');
                } else {
                    if (item.selectedEventTips && item.selectedEventTips.length) {
                        for (var j = 0; j < item.selectedEventTips.length; j++) {
                            if (item.selectedEventTips[j].id === '0' && !item.selectedEventTips[j].imageurl) {
                                item.selectedEventTips[j].imageurl = item.URL;
                            }
                        }
                        eventmark = JSON.stringify(item.selectedEventTips);
                    }
                    if (item.selectedPlaceTips && item.selectedPlaceTips.length) {
                        placemark = JSON.stringify(item.selectedPlaceTips);
                    }
                    if (item.personTips && item.personTips.length) {
                        personmark = JSON.stringify(item.personTips);
                    }
                }
                var params = {
                    relationId: item.relationid || item.relationId,
                    resourceTitle: item.fileName,
                    eventmark: eventmark,
                    personmark: personmark,
                    placemark: placemark,
                    // zyzxfield: item.selectClass.id,
                    mrEnable: $scope.status.isAddPersonalMaterial ? 1 : 0,
                    fileId: 0,
                    author: item.author,
                    filmingEvent: item.filmingevent,
                    filmingLocation: item.filminglocation,
                    filmingTime: item.filmingtime,
                    content: item.content
                };
                $scope.basicalStatus.commonParams.mrType = 'personal';
                mrApiService.updateMaterial(angular.extend(params, $scope.basicalStatus.commonParams)).then((response) => {
                    index++;
                    if (response.code !== '200') {
                        check = false;
                    }
                    if (index >= $scope.unuploadList.length) {
                        if (check) {
                            deffer.resolve();
                        } else {
                            deffer.reject();
                        }
                    }
                });
            });

            return deffer.promise;
        }

        /**
         * [finish 完成选择]
         *
         * @return  {[type]}  [return description]
         */
        $scope.finish = function () {
            let noSelectTip = options.resourceType === '0' ? '请选择图片' : options.resourceType === '1' ? '请选择音频' : '请选择视频';
            if ($scope.data.selectedNav === 'videoLink' && $scope.data.videoUrl === '') {
                noSelectTip = '请输入视频链接';
            }
            if ($scope.data.selectedNav !== '2') {
                if ($scope.selectedArray.length === 0 && $scope.data.videoUrl === '') {
                    modalDialog.alertType(noSelectTip, '', 'warning', false);
                    return;
                }
                $scope.confirm();
            } else if ($scope.data.selectedNav === '2') {
                saveMessage();
            }
        };

        /**
         * [search 搜索]
         *
         * @param   {[type]}  ev  [ev description]
         *
         * @return  {[type]}      [return description]
         */
        $scope.search = function (ev) {
            if (angular.isDefined(ev) && ev.keyCode == 13) {
                $scope.basicalStatus.searchValue = angular.copy($scope.data.keywords);
                $scope.basicalStatus.pageNum = $scope.page.CURRPAGE = '1';
                $scope.basicalStatus.copyCurrPage = 1;
                $scope.requestData();
            }
        };

        /**
         * [changeNav 切换标签]
         *
         * @param   {[type]}  nav  [nav description]
         *
         * @return  {[type]}       [return description]
         */
        $scope.changeNav = function (nav) {
            $scope.data.selectedNav = nav.value;
            $scope.data.keyWords = $scope.data.keywords = '';
            if (nav.value === '2' || nav.value === 'videoLink') {
                $scope.getAutoHeight();
            } else {
                $scope.basicalStatus.searchParams = mrApiService.resetSearchparams();
                $scope.basicalStatus.searchParams.uploadStatus = '1';
                $scope.basicalStatus.searchParams.folderFilterInWCM = '1';
                $scope.basicalStatus.isInFolder = false;
                $scope.basicalStatus.commonParams.mrType = nav.mrType;
                if (nav.value === '0' && options.resourceType === '0'){
                	$scope.basicalStatus.commonParams.isPureMaterial = '2';
                }
                if (nav.value === '0' && options.resourceType === '2'){
                	$scope.basicalStatus.searchParams.uploadStatus = '';
                	$scope.basicalStatus.searchParams.folderFilterInWCM = '';
                }
                $scope.requestData();
            }
        };

        /**
         * [getAutoHeight description] 居中提示文字
         * @return {[type]} [description]
         */
        $scope.getAutoHeight = function () {
            $timeout(function () {
                var bodyHeight = $('.publicModal .body').height(),
                    fixedAreaHeight = $('.fixedArea').height();
                var contentHeight = bodyHeight - fixedAreaHeight;
                $('.uploadContent.localUpload').height(contentHeight);
            }, 500);
        };

        /**
         * [pageChanged description]跳转到下一页
         * @return {[type]} [description]
         */
        $scope.pageChanged = function () {
            if ($scope.basicalStatus.isInFolder) {
                $scope.basicalStatus.folderSearchParams.pageNum = $scope.basicalStatus.searchParams.pageNum = $scope.basicalStatus.copyCurrPage =
                    $scope.page.CURRPAGE;
            } else {
                $scope.basicalStatus.indexParams.pageNum = $scope.basicalStatus.searchParams.pageNum = $scope.basicalStatus.copyCurrPage =
                    $scope.page.CURRPAGE;
            }
            $scope.requestData();
            $('.uploadRsource .body').animate({ scrollTop: 0 }, 'fast');
        };

        /**
         * [confirm] 确认
         * @return {[type]} [description]
         */
        $scope.confirm = function () {
            if (!options.isMulti && $scope.selectedArray.length > 1) {
                modalDialog.alertType('警告', '只能上传一个', 'warning', false);
                return;
            }
            if (options.isMulti && options.maxSize > 0 && $scope.selectedArray.length > options.maxSize) {
                modalDialog.alertType('警告', '最多只能上传' + options.maxSize + '个素材', 'warning', false);
                return;
            }
            if ($scope.isWeibo) {
                if ($scope.mainResourceType === '0') {
                    setPics($scope.selectedArray).then(function () {
                        let result = {
                            list: $scope.weiboList,
                        };
                        $modalInstance.close(result);
                    });
                } else {
                    if ($scope.selectedArray.length) {
                        setWeiboVideo($scope.selectedArray[0]);
                    }
                    $modalInstance.close({
                        list: $scope.weiboList,
                        videoUrl: $scope.data.videoUrl,
                        uploader: $scope.uploader,
                    });
                }
            } else {
                var relationId = trsspliceString.spliceString($scope.selectedArray, 'relationid', ',');
                mrApiService
                    .takeDoc({
                        mrType: $scope.basicalStatus.commonParams.mrType,
                        mainResourceType: $scope.basicalStatus.commonParams.mainResourceType,
                        relationIds: relationId,
                    })
                    .then((data) => {
                        $modalInstance.close({
                            list: data.datas,
                            isAddPersonalMaterial: $scope.status.isAddPersonalMaterial && $scope.data.selectedNav === '2',
                        });
                    });
            }
        };

        /**
         * [setWeiboVideo 设置微博视频]
         * @param   {[type]}  video  [video description]
         * @return  {[type]}         [return description]
         */
        function setWeiboVideo(video) {
            let videoObj = {
                AUDIOVIDEOID: parseInt(video.videoid),
                URL: video.URL || video.useableurl,
                REMARKS: '',
                PLATFORMFLAG: 'BDVideoObject',
                ThumbImg: video.thumbimg,
                relationId: video.relationid,
                meiziId: video.resourceid,
                resourcestatus: video.resourcestatus,
            };
            $scope.weiboList.VIDEOREL = [];
            $scope.weiboList.VIDEOREL.push(videoObj);
            $scope.uploader.fastVideoInfo.status = materialConst.statusMap[$scope.weiboList.VIDEOREL[0].resourcestatus];
        }

        /**
         * [close description] 取消
         * @return {[type]} [description]
         */
        $scope.close = function () {
            $scope.unuploadList.forEach(function (element) {
                $timeout.cancel(element.fastVideoTimer);
            });
            $modalInstance.dismiss();
        };

        /**
         * [uploadVideoIframeSrc description] 输入需要展示的iframe地址
         * @return  {[type]}  [return description]
         */
        $scope.uploadVideoIframeSrc = function () {
            $scope.status.isShowTips = false;
            if ($scope.data.uploadLinkUrl.indexOf('</iframe>') > -1) {
                var $dom = $($scope.data.uploadLinkUrl);
                if (!!$dom[0]) {
                    if ($dom[0].tagName === 'IFRAME') {
                        setVideoSize();
                        // $scope.status.iframeHeight = $state.params.wxchannelid ? '464' : '480';
                        // $scope.status.iframeWidth = $state.params.wxchannelid ? '261' : '720';
                        if (($dom.attr('height') && $dom.attr('height') != '0px') || ($dom.css('height') && $dom.css('height') != '0px')) {
                            $scope.status.iframeHeight = $dom.attr('height') || $dom.css('height');
                        }
                        if (($dom.attr('width') && $dom.attr('width') != '0px') || ($dom.css('width') && $dom.css('width') != '0px')) {
                            $scope.status.iframeWidth = $dom.attr('width') || $dom.css('width');
                        }
                        if ($state.current.name === 'wxeditpage') {
                            //  表示是微信渠道
                            dealWechatVideoUrl($dom.attr('src'));
                        }
                        $scope.data.uploadLinkUrl = $sce.trustAsResourceUrl($dom.attr('src'));
                    }
                }
            } else {
                if ($scope.data.uploadLinkUrl) {
                    $scope.status.isShowTips = true;
                    $scope.status.warningInfo = '通用地址输入有误，请查看操作说明';
                    $scope.data.uploadLinkUrl = $sce.trustAsResourceUrl($scope.data.uploadLinkUrl);
                }
            }
        };

        /**
         * [confirmIframe description]保存iframe插入到编辑器中
         *
         * @return  {[type]}  [return description]
         */
        $scope.confirmIframe = function () {
            $validation
                .validate($scope.uploadVideoNew)
                .success(function () {
                    var align,
                        flag = $scope.data.alignment.curValue.value;
                    if (flag === '0') {
                        align = 'center';
                    } else if (flag === '1') {
                        align = 'left';
                    } else {
                        align = 'right';
                    }
                    let iframe;
                    if ($scope.data.uploadLinkUrl.indexOf('v.qq.com') > 0) {
                        let vid = $scope.data.uploadLinkUrl.split('?')[1].split('=')[1];
                        let style = 'position: relative;z-index:1;height:' + $scope.status.iframeHeight + 'px;width:' + $scope.status.iframeWidth + 'px;';
                        iframe = `<p style="display:inline-block;width:100%;text-align:${align};">
                                        <iframe data-vidtype="1" style="${style}" src="http://v.qq.com/iframe/preview.html?vid=${vid}" frameborder="0" align="center" allowfullscreen="1"></iframe></p>`;
                    } else {
                        iframe = [
                            "<p style='display:inline-block;width:100%;text-align:",
                            align,
                            ";'>",
                            "<iframe wechat width='",
                            $scope.status.iframeWidth,
                            "' height='",
                            $scope.status.iframeHeight,
                            "' src='",
                            $scope.data.uploadLinkUrl,
                            "' 'allowfullscreen' frameborder='",
                            $scope.status.iframeBorder ? 1 : 0,
                            "' align='",
                            align,
                            "'></iframe></p>",
                        ].join('');
                    }
                    $modalInstance.close({
                        html: [{ videoHtml: iframe }],
                        type: 'videoLink',
                    });
                })
                .error(function () {
                    modalDialog.alertType('请检查必填项!', '', 'warning', false);
                });
        };

        $scope.descriptionShow = function () {
            if ($scope.status.operationDescription) {
                $scope.status.operationDescription = false;
            } else {
                $scope.status.operationDescription = true;
            }
        };

        /**
         * [uploadVideoIframeSrc description] 输入需要展示的iframe地址
         * @return  {[type]}  [return description]
         */
        $scope.uploadVideoIframeSrc = function () {
            $scope.status.isShowTips = false;
            if ($scope.data.uploadLinkUrl.indexOf('</iframe>') > -1) {
                var $dom = $($scope.data.uploadLinkUrl);
                if (!!$dom[0]) {
                    if ($dom[0].tagName === 'IFRAME') {
                        setVideoSize();
                        // $scope.status.iframeHeight = '480';
                        // $scope.status.iframeWidth = '720';
                        if (($dom.attr('height') && $dom.attr('height') != '0px') || ($dom.css('height') && $dom.css('height') != '0px')) {
                            $scope.status.iframeHeight = $dom.attr('height') || $dom.css('height');
                        }
                        if (($dom.attr('width') && $dom.attr('width') != '0px') || ($dom.css('width') && $dom.css('width') != '0px')) {
                            $scope.status.iframeWidth = $dom.attr('width') || $dom.css('width');
                        }
                        if ($state.current.name === 'wxeditpage') {
                            //  表示是微信渠道
                            dealWechatVideoUrl($dom.attr('src'));
                        }
                        $scope.data.uploadLinkUrl = $sce.trustAsResourceUrl($dom.attr('src'));
                    }
                }
            } else {
                if ($scope.data.uploadLinkUrl) {
                    $scope.status.isShowTips = true;
                    $scope.status.warningInfo = '通用地址输入有误，请查看操作说明';
                    $scope.data.uploadLinkUrl = $sce.trustAsResourceUrl($scope.data.uploadLinkUrl);
                }
            }
        };

        /**
         * [dealWechatVideoUrl description]
         * @param   {[type]}  src  [src description]
         * @return  {[type]}       [return description]
         */
        function dealWechatVideoUrl(src) {
            if (src.indexOf('https://v.qq.com') < 0) {
                $scope.status.isShowTips = true;
                $scope.status.warningInfo = '视频链接来源非腾讯视频，无法发布，请更换视频链接';
            } else {
                $scope.status.isShowTips = false;
            }
        }

        /**
         * [isAddPersonalMaterial description]是否保存至个人素材库
         * @return {Boolean} [description]
         */
        $scope.isAddPersonalMaterial = function () {
            $scope.status.isAddPersonalMaterial = !$scope.status.isAddPersonalMaterial;
            sessionStorage.setItem('isChecked', $scope.status.isAddPersonalMaterial);
        };

        /**
         * [loadTips description] 加载标签（智能标签）
         *
         * @param   {[type]}  word  [word 标签名称]
         *
         * @param   {[type]}  type  [word 标签分类]
         *
         * @param   {[type]}  item  [word 当前素材]
         *
         * @return  {[type]}        [return description]
         */
        $scope.loadTips = function (word, type, item) {
            mrService.loadTips($scope, word, type).then(function (data) {
                // $scope.tagsData.tagsList = data;
                item[type] = data;
                item = mrService.addTag(item, data, type, word);
            });
        };

        /**
         * [initAuddingStatus 初始化审核不通过的原因]
         *
         * @param   {[type]}  item  [item 未通过审核的素材]
         *
         * @return  {[type]}        [return description]
         */
        function initAuddingStatus(item) {
            if (item.resourcestatus && item.resourcestatus === -1) {
                if (item.audidingErrors && item.length > 0) {
                    item.isShowAuditingStatus = true;
                } else {
                    let param = {
                        resourceid: item.resourceid ? item.resourceid : 0,
                        tenantId: $sessionStorage.get('curUserInfo').TENANTID,
                        userName: $sessionStorage.get('curUserInfo').USERNAME,
                    };
                    mrApiService.getErrorMsg(param).then(function (data) {
                        if (data.code === '200') {
                            item.audidingErrors = data.datas;
                            item.isShowAuditingStatus = true;
                        }
                    });
                }
            }
        }

        /**
         * [setVideoSize description] 设置视频宽高
         * @return  {[type]}  [return description]
         */
        function setVideoSize() {
            // 因为微信渠道编辑器尺寸的特殊性需要单独处理
            $scope.status.iframeHeight = $state.params.wxchannelid ? '261' : '720';
            $scope.status.iframeWidth = $state.params.wxchannelid ? '464' : '480';
        }
        $scope.showAuditing = function (item) {
            initAuddingStatus(item);
        };

        // 是否显示售价，在采编上传不显示
        $scope.isShowPrice = function() {
            return false;
        };
    },
]);
